import { render } from "./SurveyCompleted.vue?vue&type=template&id=ab63757c"
import script from "./SurveyCompleted.vue?vue&type=script&lang=js"
export * from "./SurveyCompleted.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__